import api from "../services/api";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        auditData: [],
        auditDataCount: 0
    },
  
    getters: {
  
    },
  
    mutations: {
        setAuditData(state, data) {
            state.auditData = data;
        },
        setAuditDataCount(state, count) {
            state.auditDataCount = count;
        },
        loadingAuditData(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadAuditDataComplete(state) {
            state.loading = false;
        },
        loadAuditDataError(state, err) {
            state.auditData = [];
            state.loadError = err;
        },
    },
  
    actions: {
        clearAuditData(context){
            context.commit("setAuditData", []);
            context.commit("setAuditDataCount", 0);
        },
        loadAuditData(context, options) {
            context.commit("loadingAuditData");

            api.fetchAuditData({
                params: options.params,
                success: function(response) {
                    context.commit("setAuditData", response.data.auditData);
                    context.commit("setAuditDataCount", response.data.auditDataCount[0].total);

                    if (options.success) {
                        options.success(response.data);
                    }
                },
                error: function(e) {
                    context.commit("loadAuditDataError", api.parseHttpRequestError(e));

                    if (options.error) {
                        options.error(e);
                    }
                },
                finally: function() {
                    context.commit("loadAuditDataComplete");

                    if (options.finally) {
                        options.finally();
                    }
                }
            });
        }
    }
}